<script>
import axios from 'axios'

import {
  authMethods,
  authComputed
} from "@/state/helpers";

import store from '@/state/store'

const HttpClient = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  headers: {
    'Content-Type': 'application/json'
  },
  timeout: 60000
})


export default {
  data () {
    return {

    }
  },
  computed: {
    ...authComputed
  },
  mounted () {
    if (this.$route.query.error !== null && this.$route.query.error === 'Unauthorized') {
      this.$router.push({name: 'Error-401'})
    }
    if(store.getters['auth/getIsAuthenticated'])
    {
       this.$router.push({ path: '/' })
    }
    else
    {
      this.signIn()
    }

  },
  methods: {
    ...authMethods,
    signIn () {

      let apiData = JSON.stringify({
        jti: this.$route.query.tokenid,
        audienceId: process.env.VUE_APP_AUDIENCE_ID
      })

      HttpClient({
        method: 'POST',
        baseURL: process.env.VUE_APP_BASE_API,
        url: 'api/v1/authen/portal',
        headers: {
          'content-type': 'application/json'
        },
        timeout: 20000,
        data: apiData
      }).then(response => {
        if (response.status === 201) {

         this.setIsAuthenticated({ isAuthenticated: true})
         this.setAccessToken({ accessToken: response.data})
         this.setAuthProvider({ authProvider: 'ofmconnect' })
         this.setjti({ jti: this.$route.query.tokenid})
         this.setSecretKey({ secretKey: this.$route.query.secretkey})

          if (this.$route.query.redirecturl) {
             window.location.href = `${process.env.VUE_APP_BASE_URL}${this.$route.query.redirecturl}`
          } else {
            window.location.href = process.env.VUE_APP_BASE_URL
          }
        } else if (response.status === 404) {
          this.isUser = true
        }
      }, error => {
 
        switch (error.response.data.status) {
          case 'INVALIDPASSWORD':
            this.errorMessage = 'เข้าสู่ระบบไม่สำเร็จ รหัสผ่านไม่ถูกต้อง'
            break
          case 'NOTFOUND':
            this.errorMessage = 'เข้าสู่ระบบไม่สำเร็จ ไม่พบข้อมูลชื่อผู้ใช้งาน'
            break
          case 'DISABLE':
            this.errorMessage =
                'ชื่อผู้ใช้งาน ' + this.username + ' ถูกระงับการใช้งาน'
            break
          case 'LOCK':
            this.errorMessage =
                'ชื่อผู้ใช้งาน ' +
                this.username +
                ' มีสถานะล็อค สามารถปลดล็อคได้ที่ <a href="https://myaccess.central.co.th/showLogin.cc">myaccess.central.co.th</a>'
            break
          default:
            this.errorMessage = 'ระบบ Login ผิดพลาด'
            break
        }
        this.showError = true
      }).catch(() => {
        this.isFailed = true
      })
    }
  }
}
</script>



<template>
  <div  id="portal"  class="text-center">
  </div>
</template>